<template>
  <div class="MallCustomerService" style="text-align:center;">
      商城客服部-暂无数据
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>